import type { SvgFile } from './svg-file';

export interface TemplateVariant {
    id: number;
    name: string;
    svgFile: SvgFile;
    thumbnail: string;
    template: number;
}

export interface CreativeVariant {
    id: number;
    creative: number;
    variant: TemplateVariant;
    createdBy: number;
}
